import { DevModuleComponent } from './dev-module.component';

export const routes = [
  { path: 'dev-module', component: DevModuleComponent }
];



// WEBPACK FOOTER //
// ./src/app/+dev-module/dev-module.routes.ts